export const getGeolocationIsWarning = (state) =>
  state.geolocation && state.geolocation.isWarning

export const getGeolocationLocation = (state) =>
  state.geolocation && state.geolocation.location
